import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    requestState:'init'
}

const mutations = {
    changeRequestState(state, val) {
        state.requestState = val
    }
}

export default {
    state,
    mutations
}